// import * as React from 'react';
// import { MicrositeLocation } from '../../../enums/microsite-location';

const Footer = (props: { location: any }) => {
    let styles: React.CSSProperties = {
        position: 'static'
    };

    // if (props.location == MicrositeLocation.Home || props.location == MicrositeLocation.Preview) {
    //     styles.position = 'static';
    // }

    return (
        <div className='footer' style={styles}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-9 footer-left">
                        <p>&copy;&nbsp;<span>Best Match Corporation dba National Kidney Registry</span>. All rights reserved.</p>
                        <nav>
                            <div className="menu-footer-container">
                                <ul id="footer-menu" className="menu">
                                    <li><a target="_blank" href="https://www.kidneyregistry.org/privacy-policy/">Privacy Policy</a><span></span></li>
                                    <li><a target="_blank" href="https://www.kidneyregistry.org/accessibility-statement/">Accessibility Statement</a><span></span></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <div className="col-sm-3">
                        <a href="https://www.kidneyregistry.com/" target="_blank"><img src="images/nkr-logo.svg" alt="National Kidney Registry" /></a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;